import { render, staticRenderFns } from "./reportPermissions.vue?vue&type=template&id=e07e2bb6"
import script from "./reportPermissions.vue?vue&type=script&lang=js"
export * from "./reportPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports